import type { Currency } from 'api/account';
import type { SimpleSearchFilter } from 'api/dashboard/widget';
import type { DateType } from 'api/models';
import type { ProjectFinancialsContractType } from 'api/project';
import type {
  AllocationMedium,
  AllocationMethod,
} from 'api/resource-management/types';

export enum StrategyOptions {
  LoadBalanced = 'LOAD_BALANCED',
  MaximumMargin = 'MAXIMUM_MARGIN',
  Manual = 'MANUAL',
}

export enum StepsId {
  SelectProject = 0,
  LoadResources = 1,
  PlanTeam = 2,
  OptimizeFinancial = 3,
  Allocate = 4,
}

export type ProjectDetails = {
  id: number;
  name: string;
  startDate: string;
  dueDate: string;
};

export type Step = {
  id: StepsId;
  text: string;
};

export type TeamType = {
  teamId: number;
  teamName: string;
  roleId?: number;
};

export type StepsRowData = {
  team?: TeamType;
  user?: { userId: number } | null;
  allocationStartDate?: DateType;
  allocationEndDate?: DateType;
  allocatedMinutes: number;
  allocationMethod?: AllocationMethod;
  utilization?: number;
  simpleSearchFilter?: SimpleSearchFilter;
  margin?: number;
  cost?: number;
  profit?: number;
  revenue?: number;
  dateEditable?: boolean;
  resolved: boolean;
  medium?: AllocationMedium;
  isNoMatchFoundShown: boolean;
};

export type StepsData = {
  financialContractType?: ProjectFinancialsContractType;
  projectOwner?: { userId: number };
  projectCurrency?: Currency;
  projectBudget?: number;
  budgetedHours?: number;
  budgetedMinutes?: number;
  totalAllocatedHours?: number;
  projectId?: number;
  filter?: { optimiseFor: StrategyOptions };
  rows?: StepsRowData[];
};
